import { isPrivateIp } from '@libp2p/utils/private-ip';
import {} from '@multiformats/multiaddr';
import { Circuit, IP, DNS } from '@multiformats/multiaddr-matcher';
/**
 * Returns true if the passed multiaddr is public, not relayed and we have a
 * transport that can dial it
 */
export function isPublicAndDialable(ma, transportManager) {
    // ignore circuit relay
    if (Circuit.matches(ma)) {
        return false;
    }
    const transport = transportManager.dialTransportForMultiaddr(ma);
    if (transport == null) {
        return false;
    }
    // dns addresses are probably public?
    if (DNS.matches(ma)) {
        return true;
    }
    // ensure we have only IPv4/IPv6 addresses
    if (!IP.matches(ma)) {
        return false;
    }
    return isPrivateIp(ma.toOptions().host) === false;
}
//# sourceMappingURL=utils.js.map